import { types } from 'mobx-state-tree';

export const CategoryModel = types.model({
    name: types.string,
    key: types.string,
    checked: types.boolean
});
